import classnames from 'classnames'
import React, { Component, PropTypes } from 'react'
import { Image } from 'semantic-ui-react'

import './AsyncImage.css'
import LoaderComponent from './LoaderComponent'

import '../../node_modules/semantic-ui-css/components/image.css'

export default class AsyncImage extends Component {

  static propTypes = {
    src: PropTypes.string.isRequired,
    // behavior
    loaded: PropTypes.bool,
    beginImageLoad: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    onImageLoad: PropTypes.func.isRequired,
    unloadImage: PropTypes.func,
    // optional image properties
    alt: PropTypes.string,
    className: PropTypes.string,
    cssQualifier: PropTypes.string,
    // loader properties
    loaderSize: PropTypes.string,
  }

  static defaultProps = {
    beginImageLoad: () => console.log('Set beginImageLoad in AsyncImage'),
    cssQualifier: '',
    loaderSize: '',
    loaded: false,
    onImageLoad: () => console.log('Set onImageLoad in AsyncImage'),
  }

  componentWillMount () {
    const { beginImageLoad, loaded, src } = this.props
    if (!loaded) {
      beginImageLoad(src)
    }
  }

  componentWillUnmount () {
    const { unloadImage, src } = this.props
    if (unloadImage) {
      unloadImage(src)
    }
  }

  render () {
    const {
      alt, className, cssQualifier, loaded, loaderSize, onClick, onImageLoad, src,
    } = this.props
    const divClass = classnames({
      'asyncImage': !cssQualifier,
      'asyncImage__background': !cssQualifier,
      [`asyncImage-${cssQualifier}`]: cssQualifier,
      [`asyncImage-${cssQualifier}__background`]: cssQualifier,
    })
    const imgClass = classnames(
      {
        [className]: className,  // className truthy -> use value
        'asyncImage-loaded': !cssQualifier && loaded,
        [`asyncImage-${cssQualifier}-loaded`]: cssQualifier && loaded,
      },
    )

    const delayOnLoad = () =>
      Promise.resolve(setTimeout(() => onImageLoad(src), 1000))
    return (
      <div className={divClass}>
        <Image
          alt={alt}
          className={imgClass || undefined}
          centered
          onClick={onClick}
          onLoad={delayOnLoad}
          src={src}
        />
        {!loaded && <LoaderComponent
          loaderSize={loaderSize} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/asyncImages/AsyncImageComponent.js